namespace $.$$ {

	$mol_style_define( $shm_list_head, {

		flex: {
			grow: 1,
			direction: 'column'
		},
		gap: $mol_gap.space,

		Head: {
			flex: {
				grow: 1,
			},
		},

		Title: {
			padding: $mol_gap.text,
		},

		Controls: {
			width: '100%',
			flex: {
				grow: 1,
			},
			padding: 0,
			background: {
				color: 'transparent',
			},
		},

		Filter: {
			width: '100%',
			minWidth: 0,
			maxWidth: '100%',
			alignSelf: 'stretch',
			flex: {
				shrink: 1,
				basis: 0,
			},
			Anchor: {
				width: '100%',
				minWidth: 0,
				maxWidth: '100%',
				overflow: 'hidden',
			},
			Query: {
				width: 0,
				minWidth: 0,
				flex: {
					grow: 1,
					shrink: 1,
					basis: 0,
				},
			},
			Clear: {
				flex: {
					grow: 0,
					shrink: 0,
				},
			},
		},

		Close: {
			margin: {
				left: 'auto',
			},
		},

		Sort_label: {
			padding: $mol_gap.text,
			borderTop: '1px solid var(--mol_theme_line)',
			Content: {
				padding: 0,
			},
		},

		Group_label: {
			padding: $mol_gap.text,
			Content: {
				padding: 0,
			},
		},

		Filter_label: {
			padding: $mol_gap.text,
			borderTop: '1px solid var(--mol_theme_line)',
			Content: {
				padding: 0,
			},
		},

	} )

}
